// extracted by mini-css-extract-plugin
export default {"panel":"EmployeesPanel_panel__ptlcZ","links":"EmployeesPanel_links__ifmbu","content":"EmployeesPanel_content__l1gKN"};